import { useFormContext } from 'react-hook-form';
import { Element } from 'react-scroll';

import styles from '@components/join/join.module.scss';
import LabelInput from '@components/labelInput';
import GenderFlag from './genderFlag';
import { birthDateValidator, valueRequired } from '@utils/validators/validators';
import TextFormat from '@utils/text/format';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IBirthDate {
  prefixName: string;
}

const BirthDate = ({ prefixName }: IBirthDate) => {
  const {
    watch,
    register,
    setValue,
    formState: { errors },
  } = useFormContext();

  const birthDate = watch(prefixName);

  return (
    <Element name={prefixName} className={cx('infoWrap')}>
      <div className={cx('birthDate')}>
        <LabelInput
          type="text"
          {...register(prefixName, {
            ...valueRequired,
            validate: (value: string) => {
              return birthDateValidator(value.replace(/[^0-9]/g, ''));
            },
          })}
          className={cx('input', 'type2', { error: errors.birthDate })}
          placeholder="생년월일 8자리 (예시: 20010508)"
          maxLength={10}
          onInput={(e: Record<string, any>) => setValue('birthDate', TextFormat.birthDate(e.target.value, '.'))}
          isvalue={birthDate}
          tabIndex={2}
        />
        <GenderFlag prefixName="genderFlag" />
      </div>
      {errors.birthDate && <div className={cx('infoText', 'error')}>{errors.birthDate.message as string}</div>}
      {!!birthDate?.length && !errors.birthDate && !watch('genderFlag') && (
        <div className={cx('infoText', 'error')}>{'성별을 선택해주세요.' as string}</div>
      )}
    </Element>
  );
};

export default BirthDate;
